import { IconV2 } from 'components/common/IconV2/IconV2';
import type { MediumIconV2Props } from 'components/common/IconV2/IconV2.types';

const SearchIcon = (props: MediumIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 32 32">
    <path
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M6.324 8.933a9.856 9.856 0 0 0 3.61 13.47c4.704 2.717 10.745 1.11 13.47-3.609 2.724-4.72 1.094-10.754-3.61-13.47a9.82 9.82 0 0 0-6.914-1.121c-3.61.695-5.875 3.443-6.556 4.73"
    />
    <path stroke="currentcolor" strokeLinecap="round" d="m21.747 21.163 6.23 6.23" />
  </IconV2>
);

export default SearchIcon;
